import React, { useState } from "react";
import { Link } from 'react-router-dom';
import axios from 'axios';

const ResidentialSell = () => {
  const steps = ['Basic Details', 'Property Details', 'Photos', 'Review & Submit'];
  const [activeStep, setActiveStep] = useState(0);
  const [error, setError] = useState("");

  const token = localStorage.getItem('authToken');

  // State to store form data for all steps
  const [formData, setFormData] = useState({
    basicDetails: { type: 'residential', service: 'sell', address: '' },
    propertyDetails: {
      property_type: '', building: '', locality: '', furnish_type: '',
      bhk: '', builtup: '', plot_area: '', plot_area_unit: '', plot_length: '', plot_width: ''
    },
    photos: []
  });

  const [errors, setErrors] = useState({});


  
  const handleInputChange = (step, field, value) => {

    setFormData((prev) => ({
      ...prev,
      [step]: {
        ...prev[step],
        [field]: value,
      },
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: '', // Clear error for the field being modified
    }));
  };
 

  const handleChangeFiles = (e) => {
    const { name, files } = e.target;

    if (name === 'image' && files.length > 0) {
      // Convert the FileList to an array
      const fileArray = Array.from(files);
  
     console.log(fileArray);
  
      setFormData((prev) => ({
        ...prev,
        photos: fileArray, // Replace the previous photos array with the new files
      }));
    }
    setErrors((prev) => ({
      ...prev,
      photos: '', // Clear error for photos
    }));
  
};

  const validateStep = () => {
    const newErrors = {};
    if (activeStep === 0) {
      if (!formData.basicDetails.type) newErrors.type = "Property type is required.";
      if (!formData.basicDetails.service) newErrors.service = "Service type is required.";
      if (!formData.basicDetails.address.trim()) newErrors.address = "Address is required.";
    }
    if (activeStep === 1) {
      if (!formData.propertyDetails.property_type) newErrors.property_type = "Property type is required.";
      if (!formData.propertyDetails.building.trim()) newErrors.building = "Building/Project/Society is required.";
      if (!formData.propertyDetails.locality.trim()) newErrors.locality = "Locality is required.";
      if (!formData.propertyDetails.furnish_type) newErrors.furnish_type = "Furnish type is required.";
      if (!formData.propertyDetails.share_listing) newErrors.share_listing = "Share Listing is required.";
      if (['independent_floor', 'independent_house', 'villa'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.builtup.trim()) {
          newErrors.builtup = "Build Up is required.";
        }
        if (!formData.propertyDetails.bhk) {
          newErrors.bhk = "BHK is required.";
        }
      }
      if (['plot', 'agricultural_land'].includes(formData.propertyDetails.property_type)) {
        if (!formData.propertyDetails.plot_area.trim()) {
          newErrors.plot_area = "Plot Area is required.";
        }
        if (!formData.propertyDetails.plot_length.trim()) {
          newErrors.plot_length = "Lenght is required.";
        }
        if (!formData.propertyDetails.plot_width.trim()) {
          newErrors.plot_width = "Width is required.";
        }
        if (!formData.propertyDetails.plot_area_unit.trim()) {
          newErrors.plot_area_unit = "Area Unit is required.";
        }
      }

    }
    if (activeStep === 2) {
      if (!formData.photos[0]) newErrors.files = "Please upload at least one image.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextStep = () => {
    if (validateStep()) {
      setActiveStep((prev) => prev + 1);
    }
  };


  const handleSubmit = async (e) => {
    //alert(JSON.stringify(formData));  
    e.preventDefault();


    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/residentialRent`, formData,{
        headers: {
          Authorization: `Bearer ${token}`, // Attach Bearer token
          'Content-Type': 'multipart/form-data', // Set correct content type for file upload
        },
      });
      console.log('API Response:', response.data);
      alert("Property Add SuccessFully");
    } catch (error) {
      console.error("Property Add error:", error);
      setError("An error occurred. Please try again later.");
    }
  };

  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Property Type</label>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.type === 'residential' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'type', 'residential')}
                >
                  Residential
                </button>
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.type === 'commercial' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'type', 'commercial')}
                >
                  Commercial
                </button>
              </div>
              {errors.type && <small className="text-danger">{errors.type}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Looking to</label>
              <div className="btn-group" role="group">
                <Link to="/residentialRent">
                  <button
                    type="button"
                    className={`btn ${formData.basicDetails.service === 'rent' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => handleInputChange('basicDetails', 'service', 'rent')}
                  >
                    Rent
                  </button>
                </Link>
                <button
                  type="button"
                  className={`btn ${formData.basicDetails.service === 'sell' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('basicDetails', 'service', 'sell')}
                >
                  Sell
                </button>
                <Link to="/residentialPg">
                  <button
                    type="button"
                    className={`btn ${formData.basicDetails.service === 'pg' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => handleInputChange('basicDetails', 'service', 'pg')}
                  >
                    PG/Co-living
                  </button>
                </Link>
              </div>
              {errors.service && <small className="text-danger">{errors.service}</small>}
            </div>


            <div className="mb-3">
              <label className="form-label">Address</label>
              <input
                type="text"
                className="form-control"
                value={formData.basicDetails.address}
                onChange={(e) => handleInputChange('basicDetails', 'address', e.target.value)}
              />
              {errors.address && <small className="text-danger">{errors.address}</small>}
            </div>
          </div>
        );
      case 1:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Property Type</label>
              <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'apartment' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'apartment')}
                >
                  Apartment
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'independent_floor' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'independent_floor')}
                >
                  Independent Floor
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'independent_house' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'independent_house')}
                >
                  Independent House
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'villa' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'villa')}
                >
                  Villa
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'plot' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'plot')}
                >
                  Plot
                </button>
                <button
                  type="button"
                  className={`btn ${formData.propertyDetails.property_type === 'agricultural_land' ? 'btn-primary' : 'btn-outline-primary'}`}
                  onClick={() => handleInputChange('propertyDetails', 'property_type', 'agricultural_land')}
                >
                  Agricultural Land
                </button>
              </div>
              {errors.property_type && <small className="text-danger">{errors.property_type}</small>}
            </div>



            <div className="mb-3">
              <label className="form-label">Building/Project/Society</label>
              <input
                type="text"
                className="form-control"
                value={formData.propertyDetails.building}
                onChange={(e) => handleInputChange('propertyDetails', 'building', e.target.value)}
              />
              {errors.building && <small className="text-danger">{errors.building}</small>}
            </div>

            <div className="mb-3">
              <label className="form-label">Locality</label>
              <input
                type="text"
                className="form-control"
                value={formData.propertyDetails.locality}
                onChange={(e) => handleInputChange('propertyDetails', 'locality', e.target.value)}
              />
              {errors.locality && <small className="text-danger">{errors.locality}</small>}
            </div>

            {formData.propertyDetails.property_type !== 'plot' && formData.propertyDetails.property_type !== 'agricultural_land' && (
              <div className="mb-3">
                <label className="form-label">Furnish Type</label>
                <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                  <button
                    type="button"
                    className={`btn ${formData.propertyDetails.furnish_type === 'fully_furnished' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => handleInputChange('propertyDetails', 'furnish_type', 'fully_furnished')}
                  >
                    Fully Furnished
                  </button>
                  <button
                    type="button"
                    className={`btn ${formData.propertyDetails.furnish_type === 'semi_furnished' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => handleInputChange('propertyDetails', 'furnish_type', 'semi_furnished')}
                  >
                    Semi Furnished
                  </button>
                  <button
                    type="button"
                    className={`btn ${formData.propertyDetails.furnish_type === 'unfurnished' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => handleInputChange('propertyDetails', 'furnish_type', 'unfurnished')}
                  >
                    Unfurnished
                  </button>

                </div>
                {errors.furnish_type && <small className="text-danger">{errors.furnish_type}</small>}
              </div>

            )}
            <div className="mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="shareListing"
                  checked={formData.propertyDetails.share_listing || false} // Ensure it's boolean
                  onChange={(e) => handleInputChange('propertyDetails', 'share_listing', e.target.checked)} // Use `checked`
                />
                <label className="form-check-label" htmlFor="shareListing">
                  Share the listing with the agent
                </label>
              </div>
              {errors.share_listing && <small className="text-danger">{errors.share_listing}</small>}
            </div>

            {['independent_floor', 'independent_house', 'villa'].includes(formData.propertyDetails.property_type) && (
              <>
                <div className="mb-3">
                  <label className="form-label">BHK</label>
                  <div className="btn-group flex-wrap" role="group" style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>

                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '1 rk' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '1 rk')}
                    >
                      1 RK
                    </button>
                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '1 bhk' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '1 bhk')}
                    >
                      1 BHK
                    </button>
                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '1 bhk' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '1.5 bhk')}
                    >
                      1.5 BHK
                    </button>
                    <button
                      type="button"
                      className={`btn ${formData.propertyDetails.bhk === '2 bhk' ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => handleInputChange('propertyDetails', 'bhk', '2 bhk')}
                    >
                      2 BHK
                    </button>


                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Built Up</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.propertyDetails.builtup}
                    onChange={(e) => handleInputChange('propertyDetails', 'builtup', e.target.value)}
                  />
                  {errors.builtup && <small className="text-danger">{errors.builtup}</small>}
                </div>

              </>
            )}

            {['plot', 'agricultural_land'].includes(formData.propertyDetails.property_type) && (
              <>
                <div className="mb-3">
                  <label className="form-label">Plot Area</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.propertyDetails.plot_area}
                    onChange={(e) => handleInputChange('propertyDetails', 'plot_area', e.target.value)}
                  />
                  {errors.plot_area && <small className="text-danger">{errors.plot_area}</small>}
                </div>
                <div className="mb-3">
                  <label className="form-label">Select Area Unit</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.propertyDetails.plot_area_unit}
                    onChange={(e) => handleInputChange('propertyDetails', 'plot_area_unit', e.target.value)}
                  />
                  {errors.plot_area_unit && <small className="text-danger">{errors.plot_area_unit}</small>}
                </div>
                <div className="mb-3">
                  <label className="form-label">Length</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.propertyDetails.plot_length}
                    onChange={(e) => handleInputChange('propertyDetails', 'plot_length', e.target.value)}
                  />
                  {errors.plot_length && <small className="text-danger">{errors.plot_length}</small>}
                </div>
                <div className="mb-3">
                  <label className="form-label">Width</label>
                  <input
                    type="text"
                    className="form-control"
                    value={formData.propertyDetails.plot_width}
                    onChange={(e) => handleInputChange('propertyDetails', 'plot_width', e.target.value)}
                  />
                  {errors.plot_width && <small className="text-danger">{errors.plot_width}</small>}
                </div>
              </>
            )}

          </div>
        );
      case 2:
        return (
          <div>
            <div className="mb-3">
              <label className="form-label">Upload Photos</label>
              {/* <input
                type="file"
                className="form-control"
             
                
                onChange={(e) => handleInputChange('photos', 'files', e)}
              /> */}
              <input
                type="file" 
                name='image'
                onChange={(e) => handleChangeFiles(e)}
                className="form-control"
             multiple
                
               
              />
              {errors.files && <small className="text-danger">{errors.files}</small>}
            </div>
          </div>
        );
      case 3:
        return (
          <div>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Review</label>
                <div>
                  <p>Review all the entered details:</p>
                  <pre>{JSON.stringify(formData, null, 2)}</pre>
                  <button type="submit" className="btn btn-success">
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        );
      default:
        return <p>Select a step to continue.</p>;
    }
  };

  return (
    <div className="container mt-5">
      <div className="row">
        <div className="col-md-4">
          <div className="list-group">
            {steps.map((step, index) => (
              <button
                key={index}
                className={`list-group-item ${activeStep === index ? 'active' : ''}`}
                onClick={() => setActiveStep(index)}
              >
                {step}
              </button>
            ))}
          </div>
        </div>

        <div className="col-md-8">
          <div className="card">
            <div className="card-header">{steps[activeStep]}</div>
            <div className="card-body">{renderStepContent(activeStep)}</div>
            <div className="card-footer text-end">
              {activeStep > 0 && (
                <button className="btn btn-secondary me-2" onClick={() => setActiveStep((prev) => prev - 1)}>
                  Previous
                </button>
              )}
              {activeStep < steps.length - 1 ? (
                <button className="btn btn-primary" onClick={handleNextStep}>
                  Next
                </button>
              ) : (
                <button className="btn btn-success" onClick={() => alert("Form submitted successfully!")}>
                  Submit
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResidentialSell;
